import { Injectable } from '@angular/core';
import { ApplicationModel } from '@models';

@Injectable()
export class ApplicationDetailsService {
  id: string;
  application: ApplicationModel;
}
